import { render, staticRenderFns } from "./TabsMetrik.vue?vue&type=template&id=0d925b20&scoped=true&"
import script from "./TabsMetrik.vue?vue&type=script&lang=js&"
export * from "./TabsMetrik.vue?vue&type=script&lang=js&"
import style0 from "./TabsMetrik.vue?vue&type=style&index=0&id=0d925b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d925b20",
  null
  
)

export default component.exports